export default class Account {
  constructor() {
    this.currentPortfolio = null;
    this.targetPortfolio = null;
  }
}
